import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const inputClass = "bg-transparent border-[#262626] text-white placeholder:text-[#555] focus:border-[#FF3B30] focus:ring-0 rounded-none font-body";

function Field({ label, required, children }) {
  return (
    <div className="space-y-2">
      <label className="block text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-body">
        {label} {required && <span className="text-[#FF3B30]">*</span>}
      </label>
      {children}
    </div>
  );
}

function DropdownField({ label, required, testId, value, onChange, options }) {
  return (
    <Field label={label} required={required}>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className={inputClass}><SelectValue placeholder="Select..." /></SelectTrigger>
        <SelectContent className="bg-[#111111] border-[#262626] text-white">
          {Object.entries(options).map(([k, v]) => (
            <SelectItem key={k} value={v} className="hover:bg-[#262626] focus:bg-[#262626] focus:text-white">{v}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
  );
}

export function AboutRiderSection({ t, form, u }) {
  return (
    <div>
      <h2 className="font-heading text-xl uppercase tracking-wider text-white mb-6 border-b border-[#262626] pb-3">{t.aboutRider}</h2>
      <div className="space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Field label={t.riderName} required><Input data-testid="survey-rider-name" className={inputClass} value={form.rider_name} onChange={(e) => u("rider_name", e.target.value)} /></Field>
          <Field label={t.ageDob} required><Input data-testid="survey-age" className={inputClass} value={form.age_dob} onChange={(e) => u("age_dob", e.target.value)} placeholder="16 / 2010-03-15" /></Field>
          <Field label={t.country} required><Input data-testid="survey-country" className={inputClass} value={form.country} onChange={(e) => u("country", e.target.value)} /></Field>
          <DropdownField label={t.discipline} required testId="survey-discipline" value={form.discipline} onChange={(v) => u("discipline", v)} options={t.disciplines} />
          <DropdownField label={t.level} required testId="survey-level" value={form.level} onChange={(v) => u("level", v)} options={t.levels} />
          <Field label={t.yearsRiding}><Input data-testid="survey-years" className={inputClass} value={form.years_riding} onChange={(e) => u("years_riding", e.target.value)} /></Field>
        </div>
        <Field label={t.results}><Textarea data-testid="survey-results" className={`${inputClass} min-h-[80px]`} value={form.notable_results} onChange={(e) => u("notable_results", e.target.value)} /></Field>
        <Field label={t.goals} required><Textarea data-testid="survey-goals" className={`${inputClass} min-h-[80px]`} value={form.goals} onChange={(e) => u("goals", e.target.value)} /></Field>
      </div>
    </div>
  );
}

export function ProgrammeSection({ t, form, u }) {
  return (
    <div>
      <h2 className="font-heading text-xl uppercase tracking-wider text-white mb-6 border-b border-[#262626] pb-3">{t.programme}</h2>
      <div className="space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <DropdownField label={t.option} required testId="survey-programme" value={form.programme_interest} onChange={(v) => u("programme_interest", v)} options={t.options} />
          <DropdownField label={t.start} required testId="survey-start" value={form.preferred_start} onChange={(v) => u("preferred_start", v)} options={t.starts} />
        </div>
        <Field label={t.howHeard}><Input data-testid="survey-how-heard" className={inputClass} value={form.how_heard} onChange={(e) => u("how_heard", e.target.value)} /></Field>
      </div>
    </div>
  );
}

export function BudgetSection({ t, form, u }) {
  return (
    <div>
      <h2 className="font-heading text-xl uppercase tracking-wider text-white mb-6 border-b border-[#262626] pb-3">{t.budget}</h2>
      <div className="space-y-5">
        <DropdownField label={t.costGuide} required testId="survey-cost-guide" value={form.reviewed_cost_guide} onChange={(v) => u("reviewed_cost_guide", v)} options={t.costReviewed} />
        <DropdownField label={t.budgetFit} required testId="survey-budget" value={form.budget_fit} onChange={(v) => u("budget_fit", v)} options={t.budgetFits} />
        <Field label={t.financial}><Input data-testid="survey-financial" className={inputClass} value={form.financial_support} onChange={(e) => u("financial_support", e.target.value)} /></Field>
        <DropdownField label={t.readiness} required testId="survey-readiness" value={form.readiness} onChange={(v) => u("readiness", v)} options={t.readinessOpts} />
      </div>
    </div>
  );
}

export function ContactSection({ t, form, u }) {
  return (
    <div>
      <h2 className="font-heading text-xl uppercase tracking-wider text-white mb-6 border-b border-[#262626] pb-3">{t.contact}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Field label={t.parentName} required><Input data-testid="survey-parent-name" className={inputClass} value={form.parent_name} onChange={(e) => u("parent_name", e.target.value)} /></Field>
        <Field label={t.parentEmail} required><Input data-testid="survey-parent-email" type="email" className={inputClass} value={form.parent_email} onChange={(e) => u("parent_email", e.target.value)} /></Field>
        <Field label={t.phone}><Input data-testid="survey-phone" className={inputClass} value={form.phone_whatsapp} onChange={(e) => u("phone_whatsapp", e.target.value)} /></Field>
      </div>
      <div className="mt-5">
        <Field label={t.anythingElse}><Textarea data-testid="survey-notes" className={`${inputClass} min-h-[80px]`} value={form.anything_else} onChange={(e) => u("anything_else", e.target.value)} /></Field>
      </div>
    </div>
  );
}
